import CodeForm from "./CodeForm";
import "./Content.css";
import ImageLists from "./ImageLists";
import Tiles from "./Tiles";

const Content = () => {
	return (
		<div className="content">
			<div className="content__heading">
				<h1 style={{ fontFamily: "Recursive" , textTransform: "uppercase" }}>Free Image and Photo Resizer Online</h1>
				<hr className="new1" />
				<p>
					Change the size of any image using our quick, simple, and free online image resizer. Use our easy picture resizer to instantly resize your images to a custom dimension or for social media. Do you want to know how to make an image bigger, vertical, or horizontal? You can quickly change the size and proportions of any image using our free online photo resizer, making it ideal for printing, sharing to social media, and more. Can't seem to find the size you want. Custom sizes can also be defined!
			</p>
			</div>

			<a className="content__link" href="#imageForm">
				<h2>Upload and resize images</h2>
			</a>
			<Tiles />
			<CodeForm />
			<ImageLists />

			<div className="content__segment">
				<h2>What is an Image Resizer?</h2>
				<p>
					Image Resizer is browser-based (no software to install) that automatically resize your image into every standard size for social media, print, web, and more all in one place. Our simple image resizer tool changes how big or small an image is (using pixel measurements) as well as the option to change the aspect ratio (the shape of the image). Our online image resizer makes image resizing a breeze. Start by uploading your image in JPG, PNG or WEBP format, then select the destination to choose the size you need. Apart from the standard image aspect-ratio presets, the tool also includes presets for all social media channels like Instagram, Facebook, Twitter, Snapchat, TikTok, YouTube, Pinterest, and more. Your images are uploaded via a secure 256-bit encrypted SSL connection and deleted automatically within few hours.
				</p>
			</div>

			<div className="content__segment">
			<h2>How to Resize an Image?</h2>
			<p>1. Click on the <b>Upload Image</b> button or provide the <b>Image URL</b> to upload an image.{" "}</p>
			<p>2. Click Next and enter a new target size for your image.{" "}</p>
			<p>3. Click the <b>Download</b> button and get the resized image.</p>
			</div>

			<div className="content__segment">
				<h2>How can I resize an image without compromising the quality of the image?</h2>
				<p>
					While scaling up can worsen image quality, scaling down shouldn't. A warning banner will appear if you choose a preset size for image resizing and it can degrade image quality. To achieve the correct aspect ratio based on your original image size and keep as much quality as possible, try using the Standard menu size options.
				</p>
			</div>
			
			<div className="content__segment">
				<h2>Can I resize a photo on my phone?</h2>
				<p>
					Absolutely Yes! Quickly and easily resize images on the go using your mobile and handheld device, no app download is necessary.
				</p>
			</div>
			
		</div>
	);
};

export default Content;